module.exports = __webpack_public_path__ + "img/mobile-banner1.f45c63ac.png";